/** Keep sign-in return destinations within the application. */
export function getReturnTo(search: string, fallback = '/dashboard'): string {
  const value = new URLSearchParams(search).get('returnTo');
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u001f]/.test(value)) return fallback;
  const url = new URL(value, 'https://app.invalid');
  if (url.origin !== 'https://app.invalid' || !/^\/(docs|dashboard)(?:\/|$)/.test(url.pathname)) return fallback;
  return `${url.pathname}${url.search}${url.hash}`;
}

export function authLink(path: '/login' | '/signup', returnTo: string): string {
  return `${path}?${new URLSearchParams({ returnTo })}`;
}
